/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedLimitOrderResponse,
  PagedPositionResponse,
} from '../models/index';

export interface GetGroupLimitOrdersRequest {
    blockChain: GetGroupLimitOrdersBlockChainEnum;
    groupName: string;
    pairBase?: string;
    page?: number;
    size?: number;
}

export interface GetGroupPositionsRequest {
    blockChain: GetGroupPositionsBlockChainEnum;
    groupName: string;
    pairBase?: string;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class GroupPositionControllerApi extends runtime.BaseAPI {

    /**
     */
    async getGroupLimitOrdersRaw(requestParameters: GetGroupLimitOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedLimitOrderResponse>> {
        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getGroupLimitOrders().'
            );
        }

        if (requestParameters['groupName'] == null) {
            throw new runtime.RequiredError(
                'groupName',
                'Required parameter "groupName" was null or undefined when calling getGroupLimitOrders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['pairBase'] != null) {
            queryParameters['pair_base'] = requestParameters['pairBase'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/group/{group_name}/limit-orders`.replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters['groupName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGroupLimitOrders(requestParameters: GetGroupLimitOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedLimitOrderResponse> {
        const response = await this.getGroupLimitOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGroupPositionsRaw(requestParameters: GetGroupPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedPositionResponse>> {
        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getGroupPositions().'
            );
        }

        if (requestParameters['groupName'] == null) {
            throw new runtime.RequiredError(
                'groupName',
                'Required parameter "groupName" was null or undefined when calling getGroupPositions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['pairBase'] != null) {
            queryParameters['pair_base'] = requestParameters['pairBase'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/group/{group_name}/positions`.replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters['groupName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGroupPositions(requestParameters: GetGroupPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedPositionResponse> {
        const response = await this.getGroupPositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetGroupLimitOrdersBlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetGroupPositionsBlockChainEnum {
    Monad = 'MONAD'
}
